/*
 *
 * User reducer
 *
 */

export const Types = {
  // Obtem catergorias
  GET_REQUEST: 'user/GET_REQUEST',
  GET_SUCCESS: 'user/GET_SUCCESS',
  GET_FAILURE: 'user/GET_FAILURE',

  GET_REPORT_REQUEST: 'user/GET_REPORT_REQUEST',
  GET_REPORT_SUCCESS: 'user/GET_REPORT_SUCCESS',
  GET_REPORT_FAILURE: 'user/GET_REPORT_FAILURE',

  GET_REPORT_CHILD_REQUEST: 'user/GET_REPORT_CHILD_REQUEST',
  GET_REPORT_CHILD_SUCCESS: 'user/GET_REPORT_CHILD_SUCCESS',
  GET_REPORT_CHILD_FAILURE: 'user/GET_REPORT_CHILD_FAILURE',

  GET_MY_USER_REQUEST: 'user/GET_MY_USER_REQUEST',
  GET_MY_USER_SUCCESS: 'user/GET_MY_USER_SUCCESS',
  GET_MY_USER_FAILURE: 'user/GET_MY_USER_FAILURE',

  // Obtem catergorias
  GET_LIST_REQUEST: 'user/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'user/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'user/GET_LIST_FAILURE',

  // Insere uma catergoria
  GET_INSERT_REQUEST: 'user/GET_INSERT_REQUEST',
  GET_INSERT_SUCCESS: 'user/GET_INSERT_SUCCESS',
  GET_INSERT_FAILURE: 'user/GET_INSERT_FAILURE',

  // Atualiza uma catergoria
  GET_UPDATE_REQUEST: 'user/GET_UPDATE_REQUEST',
  GET_UPDATE_SUCCESS: 'user/GET_UPDATE_SUCCESS',
  GET_UPDATE_FAILURE: 'user/GET_UPDATE_FAILURE',

  // Deleta uma catergoria
  GET_DELETE_REQUEST: 'user/GET_DELETE_REQUEST',
  GET_DELETE_SUCCESS: 'user/GET_DELETE_SUCCESS',
  GET_DELETE_FAILURE: 'user/GET_DELETE_FAILURE',

  GET_ATIVATE_REQUEST: 'user/GET_ATIVATE_REQUEST',
  GET_ATIVATE_SUCCESS: 'user/GET_ATIVATE_SUCCESS',
  GET_ATIVATE_FAILURE: 'user/GET_ATIVATE_FAILURE',
};

export const initialState = {
  // Categoria por id
  myUser: {},
  myUserLoading: false,
  myUserError: null,
  // Categoria por id
  user: {},
  userLoading: false,
  userError: null,
  // Lista de categorias
  userList: [],
  dataReport: [],
  totalReport: 0,
  loadingReport: false,
  dataReportChild: [],
  totalReportChild: 0,
  loadingReportChild: false,
  userListLoading: false,
  userListError: null,
  userListTotal: 0,
  // Insere uma categoria
  userInsertLoading: false,
  userInsertError: false,
  // Atualiza uma categoria
  userUpdateLoading: false,
  userUpdateError: false,
  // Deleta categoria
  userDeleteLoading: false,
  userDeleteError: null,
  // ativa/desativa
  userAtivateLoading: false,
  userAtivateError: null,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Categoria por id
    case Types.GET_MY_USER_REQUEST:
      return {
        ...state,
        myUser: {},
        myUserError: null,
        myUserLoading: true,
      };
    case Types.GET_MY_USER_SUCCESS:
      return {
        ...state,
        myUser: action.payload.data,
        myUserLoading: false,
        myUserError: null,
      };
    case Types.GET_MY_USER_FAILURE:
      return {
        ...state,
        myUserLoading: false,
        myUserError: action.payload,
      };
    // Categoria por id
    case Types.GET_REQUEST:
      return {
        ...state,
        user: {},
        userError: null,
        userLoading: true,
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        user: action.payload.data,
        userLoading: false,
        userError: null,
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        userLoading: false,
        userError: action.payload,
      };
    // Lista de categorias
    case Types.GET_LIST_REQUEST:
      return { ...state, userListLoading: true };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        userList: action.payload.data,
        userListLoading: false,
        userListError: null,
        userListTotal: action.payload.total,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        userListLoading: false,
        userListError: action.payload,
      };
    case Types.GET_INSERT_REQUEST:
      return {
        ...state,
        userInsertLoading: true,
        userInsertError: null,
      };
    case Types.GET_INSERT_SUCCESS:
      return {
        ...state,
        userInsertLoading: false,
        userInsertError: null,
      };
    case Types.GET_INSERT_FAILURE:
      return {
        ...state,
        userInsertLoading: false,
        userInsertError: action.payload,
      };
    // Atualiza um categoria
    case Types.GET_UPDATE_REQUEST:
      return {
        ...state,
        userUpdateLoading: true,
        userUpdateError: null,
      };
    case Types.GET_UPDATE_SUCCESS:
      return {
        ...state,
        myUser: action.payload,
        userUpdateLoading: false,
        userUpdateError: null,
      };
    case Types.GET_UPDATE_FAILURE:
      return {
        ...state,
        userUpdateLoading: false,
        userUpdateError: action.payload,
      };
    // Deleta uma categoria
    case Types.GET_DELETE_REQUEST:
      return {
        ...state,
        userDeleteLoading: true,
        userDeleteError: null,
      };
    case Types.GET_DELETE_SUCCESS:
      return {
        ...state,
        userDeleteLoading: false,
        userDeleteError: null,
      };
    case Types.GET_DELETE_FAILURE:
      return {
        ...state,
        userDeleteLoading: false,
        userDeleteError: action.payload,
      };
    // ações para ativar/desativar user
    case Types.GET_ATIVATE_REQUEST:
      return {
        ...state,
        userAtivateError: null,
        userAtivateLoading: true,
      };
    case Types.GET_ATIVATE_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        userAtivateLoading: false,
        userAtivateError: null,
      };
    case Types.GET_ATIVATE_FAILURE:
      return {
        ...state,
        userAtivateLoading: false,
        userAtivateError: action.payload,
      };
    case Types.GET_REPORT_REQUEST:
      return {
        ...state,
        dataReport: [],
        totalReport: 0,
        loadingReport: false,
      };
    case Types.GET_REPORT_SUCCESS:
      return {
        ...state,
        dataReport: action.payload.data,
        loadingReport: false,
        totalReport: action.payload.total,
      };
    case Types.GET_REPORT_FAILURE:
      return {
        ...state,
        totalReport: false,
        userError: action.payload,
      };
    case Types.GET_REPORT_CHILD_REQUEST:
      return {
        ...state,
        loadingReportChild: true,
        dataReportChild: [],
        totalReportChild: 0,
      };
    case Types.GET_REPORT_CHILD_SUCCESS:
      return {
        ...state,
        dataReportChild: action.payload.data,
        loadingReportChild: false,
        totalReportChild: action.payload.total,
      };
    case Types.GET_REPORT_CHILD_FAILURE:
      return {
        ...state,
        totalReportChild: false,
        userError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Busca uma categoria
  getMyUserRequest: ({ id }) => ({
    type: Types.GET_MY_USER_REQUEST,
    payload: { id },
  }),
  getMyUserSuccess: ({ data }) => ({
    type: Types.GET_MY_USER_SUCCESS,
    payload: { data },
  }),
  getMyUserFailure: error => ({
    type: Types.GET_MY_USER_FAILURE,
    payload: error,
  }),
  // Busca uma categoria
  getUserRequest: formData => ({
    type: Types.GET_REQUEST,
    payload: formData,
  }),
  getUserSuccess: ({ data }) => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
  getUserFailure: error => ({
    type: Types.GET_FAILURE,
    payload: error,
  }),
  // Insere uma categoria
  getUserInsertRequest: ({
    email,
    password,
    name,
    cpf,
    genre,
    description,
    cell_phone,
    store,
    group,
    premium,
    address,
    status,
    birth_date,
    image_data,
  }) => ({
    type: Types.GET_INSERT_REQUEST,
    payload: {
      email,
      password,
      name,
      cpf,
      genre,
      description,
      cell_phone,
      store,
      group,
      premium,
      address,
      status,
      birth_date,
      image_data,
    },
  }),
  getUserInsertSuccess: () => ({
    type: Types.GET_INSERT_SUCCESS,
  }),
  getUserInsertFailure: error => ({
    type: Types.GET_INSERT_FAILURE,
    payload: error,
  }),
  // Busca lista de categorias
  getUserListRequest: ({
    page,
    perPage,
    search,
    orderByColumn,
    orderByDirection,
    group_id,
  }) => ({
    type: Types.GET_LIST_REQUEST,
    payload: {
      page,
      perPage,
      search,
      orderByColumn,
      orderByDirection,
      group_id,
    },
  }),
  getUserListSuccess: ({ data, total }) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { data, total },
  }),
  getUserListFailure: error => ({
    type: Types.GET_LIST_FAILURE,
    payload: error,
  }),
  // Atualiza uma  Categoria
  // Insere uma categoria
  getUserUpdateRequest: ({
    id,
    email,
    password,
    name,
    cpf,
    genre,
    description,
    cell_phone,
    birth_date,
    store,
    group,
    premium,
    address,
    status,
    image_data,
  }) => ({
    type: Types.GET_UPDATE_REQUEST,
    payload: {
      id,
      email,
      password,
      name,
      cpf,
      store,
      genre,
      description,
      cell_phone,
      birth_date,
      group,
      premium,
      address,
      status,
      image_data,
    },
  }),
  getUserUpdateSuccess: data => ({
    type: Types.GET_UPDATE_SUCCESS,
    payload: data,
  }),
  getUserUpdateFailure: error => ({
    type: Types.GET_UPDATE_FAILURE,
    payload: error,
  }),
  // Deleta uma categoria
  getUserDeleteRequest: id => ({
    type: Types.GET_DELETE_REQUEST,
    payload: { id },
  }),
  // ativa/desativa user
  getUserAtivateRequest: data => ({
    type: Types.GET_ATIVATE_REQUEST,
    payload: data,
  }),
  getAtivateDesativateSuccess: data => ({
    type: Types.GET_ATIVATE_SUCCESS,
    payload: data,
  }),
  getUserAtivateDesativateFailure: error => ({
    type: Types.GET_ATIVATE_FAILURE,
    payload: error,
  }),
  getUserDeleteSuccess: () => ({
    type: Types.GET_DELETE_SUCCESS,
  }),
  getUserDeleteFailure: error => ({
    type: Types.GET_DELETE_FAILURE,
    payload: error,
  }),
  getReportRequest: formData => ({
    type: Types.GET_REPORT_REQUEST,
    payload: formData,
  }),
  getReportSuccess: ({ data, total }) => ({
    type: Types.GET_REPORT_SUCCESS,
    payload: { data, total },
  }),
  getReportFailure: error => ({
    type: Types.GET_REPORT_FAILURE,
    payload: error,
  }),
  getReportChildRequest: formData => ({
    type: Types.GET_REPORT_CHILD_REQUEST,
    payload: formData,
  }),
  getReportChildSuccess: ({ data, total }) => ({
    type: Types.GET_REPORT_CHILD_SUCCESS,
    payload: { data, total },
  }),
  getReportChildFailure: error => ({
    type: Types.GET_REPORT_CHILD_FAILURE,
    payload: error,
  }),
};
